import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'unicon-file-field',
  templateUrl: './file-field.component.html',
})
export class FileFieldComponent implements OnInit {
  @Input() file!: File;
  @Output() delete: EventEmitter<string> = new EventEmitter<string>();
  protected isHovered: boolean = false;
  protected url: string = '';

  @HostListener('mouseenter', ['$event.target']) onMouseEnter() {
    this.isHovered = true;
  }

  @HostListener('mouseleave', ['$event.target']) onMouseLeave() {
    this.isHovered = false;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.file) {
      this.url = this.getResourceUrl(this.file);
    }
  }

  protected isImage(fileType: string): boolean {
    const acceptedTypes: string[] = ['image/jpeg', 'image/png'];
    return acceptedTypes.includes(fileType);
  }

  protected isDocument(fileType: string): boolean {
    const acceptedTypes: string[] = [
      'application/pdf',
      'application/vnd.ms-excel',
    ];
    return acceptedTypes.includes(fileType);
  }

  protected getResourceUrl(file: File): string {
    return URL.createObjectURL(file);
  }

  protected onDelete(fileName: string): void {
    this.delete.emit(fileName);
  }
}
